import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  LitterRemoveBookmarkMutation,
  LitterRemoveBookmarkMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';
import { MT_WISHLIST_GET_BOOKMARKS } from '../../MtWishlistPageController/api/useGetBookmarks';
import { LITTER_GET_BOOKMARK } from './useGetBookmark';

export const LITTER_REMOVE_BOOKMARK = graphql(`
  mutation LitterRemoveBookmark($data: AccountUpdateInput!) {
    accountMeUpdate(data: $data) {
      id
      bookmarks {
        id
        litter {
          id
        }
      }
    }
  }
`);

export const useRemoveBookmark = () => {
  const [remove, { data, loading, error }] = useMutation<
    LitterRemoveBookmarkMutation,
    LitterRemoveBookmarkMutationVariables
  >(LITTER_REMOVE_BOOKMARK, {
    awaitRefetchQueries: true,
    refetchQueries: [LITTER_GET_BOOKMARK, MT_WISHLIST_GET_BOOKMARKS],
  });

  const removeBookmark = useCallback(
    (litterId: number) => {
      return remove({
        variables: {
          data: {
            bookmarks: { deleteMany: [{ litterId: { equals: litterId } }] },
          },
        },
      });
    },
    [remove],
  );

  return {
    removeBookmark,
    removeBookmarkLoading: loading,
    removeBookmarkError: error,
    removeBookmarkData: data,
  };
};
